/* eslint-disable no-param-reassign */
import { EditorState, Node } from '@candulabs/craft';
import isEqual from 'lodash/isEqual';

import { richTextResolver } from './constants';
import { deleteNodes } from './deleteNodes';

// Merge any adjacent Slate nodes
export const mergeElements = (editorState: EditorState) => {
  const nodesToDelete: string[][] = [];
  Object.values(editorState.nodes).forEach((node) => {
    // if a node has no children, there is no merging or deleting to perform
    if (!node.data.nodes) {
      return;
    }

    let lastNode: Node | null = null;
    const childNodesIds = new Set<string>();

    node.data.nodes.forEach((id) => {
      const childNode = editorState.nodes[id];

      if (!childNode) {
        return;
      }

      childNodesIds.add(id);

      if (childNode.data.type !== richTextResolver) {
        lastNode = null;
        return;
      }

      if (lastNode) {
        if (lastNode.data.nodes) {
          // reverse the nodes so we can add it in the correct order via unshift()
          lastNode.data.nodes.reverse().forEach((childNodeId) => {
            editorState.nodes[childNodeId].data.parent = childNode.id;
            childNode.data.nodes.unshift(childNodeId);
          });
        }

        childNodesIds.delete(lastNode.id);
        nodesToDelete.push([lastNode.id, childNode.id]);
      }

      lastNode = childNode;

      if (!childNode.data.nodes) {
        return;
      }

      // Remove the matched element if it has no child nodes (or contains child Nodes that are all marked for deletion)
      const deletedIds = nodesToDelete.map(([deletedId]) => deletedId);
      if (
        childNode.data.nodes.length === 0 ||
        childNode.data.nodes.every((childNodeId) => deletedIds.includes(childNodeId))
      ) {
        nodesToDelete.push([id]);
      }
    });

    const nodeIds = Array.from(childNodesIds);
    // don't reassign if they are equal!
    // reassiging causes history to become polluted, requiring much more
    // memory to run the editor.
    if (!isEqual(node.data.nodes, nodeIds)) {
      node.data.nodes = nodeIds;
    }
  });

  // Cleanup deleted Nodes
  deleteNodes(editorState, nodesToDelete);
};
